import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type InsertPartsRunMutationVariables = Types.Exact<{
  run: Types.Mobility_Runs_Insert_Input;
}>;


export type InsertPartsRunMutation = { __typename?: 'mutation_root', insert_mobility_runs_one?: { __typename?: 'mobility_runs', id: number, departure_time?: string | null } | null };


export const InsertPartsRunDocument = gql`
    mutation insertPartsRun($run: mobility_runs_insert_input!) {
  insert_mobility_runs_one(object: $run) {
    id
    departure_time
  }
}
    `;
export type InsertPartsRunMutationFn = Apollo.MutationFunction<InsertPartsRunMutation, InsertPartsRunMutationVariables>;

/**
 * __useInsertPartsRunMutation__
 *
 * To run a mutation, you first call `useInsertPartsRunMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertPartsRunMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertPartsRunMutation, { data, loading, error }] = useInsertPartsRunMutation({
 *   variables: {
 *      run: // value for 'run'
 *   },
 * });
 */
export function useInsertPartsRunMutation(baseOptions?: Apollo.MutationHookOptions<InsertPartsRunMutation, InsertPartsRunMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertPartsRunMutation, InsertPartsRunMutationVariables>(InsertPartsRunDocument, options);
      }
export type InsertPartsRunMutationHookResult = ReturnType<typeof useInsertPartsRunMutation>;
export type InsertPartsRunMutationResult = Apollo.MutationResult<InsertPartsRunMutation>;
export type InsertPartsRunMutationOptions = Apollo.BaseMutationOptions<InsertPartsRunMutation, InsertPartsRunMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/insertPartsRun.mutation.gql}
 */
export async function insertPartsRun(
  variables: InsertPartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<InsertPartsRunMutation['insert_mobility_runs_one']>
export async function insertPartsRun(
  variables: InsertPartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<InsertPartsRunMutation>
export async function insertPartsRun(
  variables: InsertPartsRunMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<InsertPartsRunMutation['insert_mobility_runs_one'] | InsertPartsRunMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<InsertPartsRunMutation>(
    InsertPartsRunDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.insert_mobility_runs_one
}